import { render, staticRenderFns } from "./SchoolCategoryReport.vue?vue&type=template&id=69559756&scoped=true"
import script from "./SchoolCategoryReport.vue?vue&type=script&lang=js"
export * from "./SchoolCategoryReport.vue?vue&type=script&lang=js"
import style0 from "./SchoolCategoryReport.vue?vue&type=style&index=0&id=69559756&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69559756",
  null
  
)

export default component.exports